import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { FC, useContext, useRef, useState } from "react"
import ProjectService from "@app/projects/projectService";
import { ZipProjectContext } from "./ZipProjectContext";
import { toast } from "react-toastify";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";

interface ZipPublishProps {
  existingComment: string;
  onSubmit: () => void;
  runConfigurationId: number;
}

export const ZipProjectUpdateTimesliceCommentFlyout: FC<ZipPublishProps> = (props: ZipPublishProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const zipProjectContext = useContext(ZipProjectContext);
  const projectService = useRef(new ProjectService()).current;
  // This flyout receives the run configuration id on load
  // But also on load, the trend chart tooltip vanishes, and the run configuration id with it
  // So we have to save it here to avoid sending undefined to the API
  const selectedRunConfigId = useRef(props.runConfigurationId).current;
  const [newComment, setNewComment] = useState(props.existingComment);

  const handlePublish = () => {
    projectService.updateRunConfiguration(zipProjectContext.state.project.projectId, selectedRunConfigId, { publishComment: newComment }).then(() => {
      toast("Publish comment successfully saved.", {
        containerId: "z-index-9999",
        type: "success",
      });
      props.onSubmit();
      flyoutContext.handleCloseFlyout();
    }, () => {
      toast("Publish comment failed to save.", {
        containerId: "z-index-9999",
        type: "error",
      });
    });
  }

  return (
    <>
      <div className="col-7">
        <QESTextInput
          label="Publish Tag"
          testId="zip-project-publish-flyout__comment-input"
          value={newComment}
          onChange={(e) => { setNewComment(e.target.value) }}
          descriptiveText="This could help you recognize the time slice later."
          maxLength={50}
        />
      </div>

      <FlyoutFooter
        submitButton={
          <QESButton
            qesType="primary"
            qesTestId="zip-project-publish-flyout__publish-button"
            onClick={handlePublish}
          >
            Publish
          </QESButton>
        }
      />
    </>
  )
};
